<script setup lang="ts">
import {computed, type HTMLAttributes, ref, onMounted, onBeforeUnmount} from 'vue'
import {DialogContent, type DialogContentProps, DialogOverlay, DialogPortal, useForwardPropsEmits,} from 'radix-vue'
import {cn} from '@/shared/lib/utils'
import {useDialog} from "@/shared/components/ui/dialog/use-dialog.ts";

const {_dialog, closeDialog} = useDialog()

interface DialogEmits {
  (e: 'update:close'): void;
}

const props = defineProps<DialogContentProps & { class?: HTMLAttributes['class']; 'aria-describedby'?: string }>()
const emits = defineEmits<DialogEmits>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)

const close = () => {
  if(_dialog.value.easyClose) {
    closeDialog(false)
  }
}

</script>

<template>
  <DialogPortal>
    <DialogOverlay
      class="fixed inset-0 z-50 bg-black/70  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
    />
    <DialogContent
      v-bind="forwarded"
      :class="
        cn(
          'fixed left-1/2 top-1/2 z-50 grid w-full max-w-lg -translate-x-1/2 -translate-y-1/2 gap-4 border border-slate-200 bg-white p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg dark:border-slate-800 dark:bg-slate-950',
          props.class,
        )"
    >
      <slot />
    </DialogContent>
  </DialogPortal>
</template>
